import {Button} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Loading from "../Loading";
import {VariantItem} from "./VariantItem";
import {useVariantAllQuery, useVariantBaseQuery} from "../../core/reducers/variant";

export const BaseVariants = ({filterText, filterType, setOpenCreate, env}) => {

    const {
        data: variantsBase,
        isLoading,
        isError,
        error
    } = useVariantAllQuery({type: filterType,env: env},{pollingInterval: 5000})


    return <>
        <div className="campaign-group">

            <div className="campaign-type-title">
                <span>Base variants</span>
                <Button size={"small"} sx={{ml:2,minWidth:'0'}} variant={"outlined"} onClick={()=>setOpenCreate(true)}><AddIcon /></Button>

            </div>

            <div className="campaigns-list variants">
                <Loading isLoading={isLoading} isError={isError} error={error}>
                    {variantsBase!=undefined && variantsBase.baseVariants.filter(item => filterText==''||item.bundleId.indexOf(filterText)>=0).map((item) => (<VariantItem  env={env} parent={variantsBase.testVariants.filter(_item=>_item.bundleId==item.bundleId)} variant={"base"} item={item} />))}
                </Loading>

            </div>
        </div>
    </>

}